import React, { useEffect, useRef, useState } from 'react'
import { useGoodsGuigeUpdateQuery, useGoodsGuigeUpdateSaveMutation } from '../../store/ReactWebSiteApi';
import { Modal, Form, Input, App } from 'antd';

function GoodsSpecEdit(props) {
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [editGoods,setEditGoods] = useState({egg_remark:''});
    
    const editForm = useRef()
    const {data:dataEdit,isSuccess:isSuccessEdit} = useGoodsGuigeUpdateQuery({egg_id:props.egg_id},{skip:!open})
    useEffect(() => {
        if(isSuccessEdit){
            if(dataEdit.Status==='success'){
                console.log(dataEdit);                
                editForm.current.setFieldsValue({
                    egg_name:dataEdit.Result.egg_name,
                })
                setEditGoods(prevState=>({...prevState,
                    egg_name:dataEdit.Result.egg_name,                  
                }))
            }
        }
    },[dataEdit,isSuccessEdit])
    const [goodsEdit] = useGoodsGuigeUpdateSaveMutation()
    return (
        <>
            <a  onClick={() => {setOpen(true);}}>修改</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改规格'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            console.log('Validate Failed:', info);
                        });
                    goodsEdit({
                        egg_name:editGoods.egg_name,
                        egg_eg_id:props.egg_eg_id,
                        egg_update_uid:localStorage.getItem('eu_id'),
                        egg_e_id:localStorage.getItem('e_id'),
                        egg_update_uname:localStorage.getItem('eu_name'),
                        egg_id:props.egg_id,                                   
                    }).then((res) => {
                        console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizontal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 5 }}
                    ref={editForm}
                >
                    
                    <Form.Item name="egg_name" label='规格名称' wrapperCol={{span:10}} required>
                        <Input  onChange={(e) => {setEditGoods(prevState=>({...prevState,egg_name:e.target.value}))}}/>
                    </Form.Item>                                
                </Form>
            </Modal> 
        </>
    )
}

export default GoodsSpecEdit